// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-header {
    display: flex;
    margin-bottom: 1rem;
    margin-left: 5px;
    height: 32px;
  }
  
  .tab-inactive {
    border-radius: 8px;
    padding-left: 8px;
    padding-right: 8px;
    cursor: pointer;
    border: none;
    background-color: var(--tab-backcolor-inactive-tab);
    margin-right: 5px;
    transition: background-color 0.3s ease;
  }
  
  .tab-active {
    border-radius: 8px;
    border-color: gray;
    border-style: solid;
    border-width: 1px;
    padding-left: 8px;
    padding-right: 8px;
    margin-right: 5px;
    cursor: pointer;
    
    background-color: var(--tab-backcolor-active-tab);
    color: white;
  }
  
  .tab-content {
    margin-left: 5px;
    height: calc(100% - 48px);
    background-color: var(--tab-backcolor-content);
    border-radius: 5px;
  }`, "",{"version":3,"sources":["webpack://./src/components/bases/tabcontrol/tabcontrol.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mDAAmD;IACnD,iBAAiB;IACjB,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;;IAEf,iDAAiD;IACjD,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,8CAA8C;IAC9C,kBAAkB;EACpB","sourcesContent":[".tabs-header {\n    display: flex;\n    margin-bottom: 1rem;\n    margin-left: 5px;\n    height: 32px;\n  }\n  \n  .tab-inactive {\n    border-radius: 8px;\n    padding-left: 8px;\n    padding-right: 8px;\n    cursor: pointer;\n    border: none;\n    background-color: var(--tab-backcolor-inactive-tab);\n    margin-right: 5px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .tab-active {\n    border-radius: 8px;\n    border-color: gray;\n    border-style: solid;\n    border-width: 1px;\n    padding-left: 8px;\n    padding-right: 8px;\n    margin-right: 5px;\n    cursor: pointer;\n    \n    background-color: var(--tab-backcolor-active-tab);\n    color: white;\n  }\n  \n  .tab-content {\n    margin-left: 5px;\n    height: calc(100% - 48px);\n    background-color: var(--tab-backcolor-content);\n    border-radius: 5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
